import { typeahead } from "@mirage/service-typeahead-search/service/types";
import { isInsideExtensionSidePanel } from "@mirage/shared/util/webExtensionsHelpers";
import { atom } from "jotai";

const baseModeAtom = atom<typeahead.Mode>(typeahead.Mode.Default);

export const ModeAtom = atom(
  (get) =>
    isInsideExtensionSidePanel() ? typeahead.Mode.Find : get(baseModeAtom),
  (_get, set, newValue: typeahead.Mode) => {
    if (isInsideExtensionSidePanel()) return;
    set(baseModeAtom, newValue);
  },
);
